import React from 'react'
import { Link } from 'react-router-dom'

export default function ProfilesSetup() {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Profiles + Setup AI</div>
          <div className="text-muted fs12 mt4">
            Rider profiles mirror the workshop customer record. Setup records live on each verified fork or shock.
          </div>
        </div>
        <div className="page-actions">
          <Link className="btn btn-primary" to="/customers">Open Customers</Link>
          <Link className="btn btn-ghost" to="/settings?tab=specs">Component Specs</Link>
        </div>
      </div>

      <section className="card">
        <div className="section-head compact">
          <div>
            <div className="card-title">How It Works</div>
            <div className="text-muted fs12">No separate workshop workflow is needed.</div>
          </div>
        </div>
        <div className="portal-detail-grid">
          <div className="portal-detail">
            <span>Workshop source of truth</span>
            <strong>Customers - bike - components - service jobs</strong>
          </div>
          <div className="portal-detail">
            <span>Verified setup</span>
            <strong>Saved from after-service settings</strong>
          </div>
          <div className="portal-detail">
            <span>Rider portal</span>
            <strong>Same bikes, same components, rider variants</strong>
          </div>
        </div>
      </section>

      <section className="card">
        <div className="card-title">Current Build Boundary</div>
        <div className="text-muted fs12" style={{ lineHeight: 1.8, marginTop: 8 }}>
          Use the existing customer cards to manage bikes, suspension components and jobs.
          When a technician records after-service setup settings on a job, Rebound updates the
          verified setup for that component. Riders can then view that component setup and save
          their own variants in the rider portal.
        </div>
      </section>
    </>
  )
}
